import React from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'

import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TextField } from 'src/Libs/inputs/react-hook-form'
import { ChargingScheduleFormFieldNames } from 'src/Libs/e-mobility/vehicle-integration'

interface Props {
  scheduleNamePlaceholderKey: string | null
  scheduleCounter: number
  temporaryScheduleName?: string
}

/**
 * Schedule name form part
 */
const ScheduleName: React.FC<Props> = ({ scheduleCounter, scheduleNamePlaceholderKey, temporaryScheduleName }) => {
  const { t } = useCustomTranslation()
  const placeholderName = temporaryScheduleName ?? `${scheduleNamePlaceholderKey} ${scheduleCounter + 1}`

  return (
    <Box>
      <Typography variant="h3">{t('emobility.vehicle-integration.charging-schedule.schedule-name-label')}</Typography>
      <TextField name={ChargingScheduleFormFieldNames.ScheduleName} sx={{ mt: 1, width: '100%' }} placeholder={placeholderName} />
    </Box>
  )
}

export default ScheduleName
